module.exports = __webpack_public_path__ + "img/flecha-regresar-verde.b553dbda.svg";